import { FC } from 'react'
import Link from 'next/link'
import styled from 'styled-components'
import sortBy from 'lodash.sortby'
import Aside from 'src/components/Aside/Aside'
import { Image, Figcaption, Props } from 'src/containers/Home/components/Artist'

const ListContainer = styled.section`
  display: flex;
  margin: 0 auto;
  margin-top: 48px;
  max-width: 1200px;
`

const Figure = styled.figure`
  display: inline-block;
  margin: 0 0 24px 24px;
`

const ArtistList: FC<Props> = ({ artists }) => {
  return (
    <ListContainer>
      <Aside />
      <div>
        {sortBy(artists, 'createdAt').map((artist) => {
          const { _id, name, avatarUrl } = artist
          return (
            <Link href={`artist/${_id}`} key={_id}>
              <a>
                <Figure>
                  <Image src={avatarUrl} alt={name} />
                  <Figcaption>{name}</Figcaption>
                </Figure>
              </a>
            </Link>
          )
        })}
      </div>
    </ListContainer>
  )
}

export default ArtistList
